import React from 'react'

import ProjectCarouselButtons from '../ProjectCarouselButtons'

const TextClassification = () => {
    return (
        <>
            <div className="Project--split--window">
                <div className="Project-Carousel-info-container">
                    <div id="carouselExampleIndicatorsTextClassification" className="carousel slide Project-Carousel-container">

                        <div className="carousel-inner">
                            <div className="carousel-item active">
                            <video controls="controls" className="d-block w-100">
                                    <source src="../IMG/TextClassification/TextClassification.mp4" type="video/mp4" />
                                </video>
                            </div>
                        </div>

                        <ProjectCarouselButtons tag="TextClassification" />

                    </div>

                    <div className="Project-info-container">
                        <div className="Project--info--Para-container">
                            <p className="Project--info--heading">Text Classification</p>
                            <p className="Project--info--subheading">Movie Review Analysis</p>
                            <p className="Project--info--subheading">ML/AI Development</p>
                            <p className="Project--info--Para">Text classification, a subset of natural language processing (NLP), involves categorizing text documents into predefined classes or categories based on their content. In this code example, text classification is applied to IMDb movie reviews, categorizing them as positive or negative.</p>
                            <p className="Project--info--Para">The code loads IMDb movie reviews, preprocesses them by encoding and padding, defines a neural network model using Keras, trains it, evaluates performance, and saves and predicts sentiment.</p>
                        </div>
                        {/* <div className="Project--info--links">
                            <a href="https://github.com/Chauhan-Aman/JAMSHACK23_UnityServe" target='__blank'>Github</a>
                        </div> */}
                        <div className="Project--info--tech">
                            <p>Python</p>
                            <p>TensorFlow</p>
                            <p>Keras</p>
                            <p>Numpy</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TextClassification